import { useRuntimeConfig } from "@finbackoffice/site-core";
import { SkinVersions } from "utils/constants";

const useSkinVersion = () => {
    const COMMON_SITE_CONFIGS = useRuntimeConfig("COMMON_SITE_CONFIGS");
    const skinVersion = COMMON_SITE_CONFIGS.skinVersion;

    return {
        skinVersion,
        isBetmidas: skinVersion == SkinVersions.Betmidas,
        isXrpBet: skinVersion === SkinVersions.Xrpbet,
        isBrazilianSkin: [SkinVersions.Betmidas, SkinVersions.Oddsgate].includes(
            skinVersion as SkinVersions,
        ),
        isBettorian: skinVersion === SkinVersions.Bettorian,
    };
};

export default useSkinVersion;
